import { render, staticRenderFns } from "./property-web-preview-view.vue?vue&type=template&id=947ed1ba"
import script from "./property-web-preview-view.vue?vue&type=script&lang=js"
export * from "./property-web-preview-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports